import { Outlet } from 'react-router-dom'

/**
 * Shell del área PÚBLICA (landing + auth). El `<Outlet />` proyecta la landing o
 * las pantallas de login/registro/recuperar.
 */
export function PublicLayout() {
  return <Outlet />
}
